const MATCH_PATTERN_PHONE = '^\\+?[0-9 ]+$';
const BASIC_TEXT_PATTERN = '^[-_0-9a-zA-Z,\'.$%! ]+$';
const EMPTY_STRING_REGEXP = /^\s*$/;
const NUMBER_ONLY_PATTERN = '^[0-9\b]+$';
const regexp =
    /[a-z0-9!#$%&'*+/=?^_`{|}~.-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)+/i;
const regexpCaiman = /^[a-zA-Z0-9\._-]+@[a-zA-Z0-9\.-]+\.[a-zA-Z]{2,64}$/;
const DOT_AT_END = /@[A-Za-z0-9\.-]+\.[A-Za-z]+\.$/;
const AT_THE_RATE_AT_END = /@[A-Za-z0-9\.-]+\.[A-Za-z]+\@$/;
const HYPHEN_AT_END = /@[A-Za-z0-9\.-]+\.[A-Za-z]+\-$/;
const UNDERSCORE_AT_END = /@[A-Za-z0-9\.-]+\.[A-Za-z]+\_$/;
const SPACE_CHECK = /\s/;
const MATCH_TEXT_HYPHENS = /^[a-zA-Z\&\-'\s]+$/;
const EMAIL_CHARACTER_ALLOWED = /^[a-zA-Z0-9\.\_\-\@]+$/;
const MATCH_AUS_PATTERN_PHONE = '^(04|\\+614)[0-9]+$';
const MATCH_PHONE_LENGTH = /^(\+)\d{11}(\d{2})?$/;
const MATCH_PHONE_NUMBER_ALLOWED = /^\+?[0-9]+$/;
const MOBILE_NUMBER_INCLUDING_PLUS = '^[0-9\+]+$';
const MAX_LENGTH = /^.{1,50}$/;
const MAX_EMAIL_LENGTH = /^.{1,64}$/;
const FIRST_NAME_LENGTH = /^.{2,40}$/;
const NAME_LENGTH = /^.{2,50}$/;
const NAME_STARTING_WITH_SPACE = /^\s/;
const SPACES_AROUND_HYPHEN = /\s\-|\-\s/;
const DOUBLE_HYPHEN = /\-{2,}/;
const CHARACTER_REPEAT = /([a-zA-Z\&\-'])(\1{2,})+/i;
const RESERVED_NAMES_CONFIG = {
    'DOB': 'DOB',
    'ACN': 'ACN',
    'REMOVED': 'REMOVED',
    'LTD': 'LTD',
    'LIMITED': 'LIMITED',
    'BLANK': 'BLANK',
    'SP': 'SP',
    'NOT PROVIDED': 'NOT PROVIDED',
    'COMPANY': 'COMPANY',
    'SENIOR': 'SENIOR',
    'PROF': 'PROF',
    '(LTD)': '(LTD)',
    'TRUST': 'TRUST',
    'PTYLTD': 'PTYLTD',
    'ABN': 'ABN',
    'DELETED': 'DELETED',
    'PTY': 'PTY',
    'PASSWORD': 'PASSWORD',
    'NO NAME': 'NO NAME',
    'REP': 'REP',
    'NONE': 'NONE',
    'PROPRIETARY': 'PROPRIETARY',
    'DELETE': 'DELETE',
    'ORGANIZATION': 'ORGANIZATION',
    'SNR': 'SNR',
    'TRADING': 'TRADING',
    '(PTY)': '(PTY)',
    'BUSINESS OWNER': 'BUSINESS OWNER',
    'SOLETRADER': 'SOLETRADER',
    'ON BEHALF': 'ON BEHALF',
    'INC': 'INC',
    'ANONYMOUS': 'ANONYMOUS',
    'NO LIABILITY': 'NO LIABILITY',
    'MISSING': 'MISSING',
    'INCORPORATED': 'INCORPORATED',
    'UNKNOWN': 'UNKNOWN',
    'ORGANISATON': 'ORGANISATON',
    'JR': 'JR',
    'TEST': 'TEST',
    'SR': 'SR',
    'UNIT': 'UNIT',
    'PTY LTD': 'PTY LTD',
    'SOLE TRADER': 'SOLE TRADER',
    'SOLLE TRADER': 'SOLLE TRADER',
    'PARTNERSHIP': 'PARTNERSHIP',
    'PLEASE': 'PLEASE',
    'MRS': 'Mrs',
    'MR': 'Mr',
    'MS': 'Ms',
    'MISS': 'Miss',
    'DR': 'Dr',
    'MX': 'Mx',
    'DOCTOR': 'DOCTOR',
    'MISTER': 'MISTER',
    'DO NOT USE': 'do not use',
    'SIR': 'Sir',
    'BROTHER': 'Brother',
    'SISTER': 'Sister',
    'FATHER': 'Father',
    'PASTOR': 'Pastor',
    'REVEREND': 'Reverend',
    'SERGEANT': 'Sergeant'

}
function isString(value) {
    return typeof value === 'string';
}
export function isValidEmail(value: string): boolean {
    return regexp.test(value);
}

export function isValidCaimanEmail(value: string): boolean {
    return regexpCaiman.test(value);
}

export function isValidPhone(value: string): boolean {
    return !!value.match(MATCH_PATTERN_PHONE);
}

export function isBasicText(value: string) {
    return !!value.match(BASIC_TEXT_PATTERN);
}

export function isValueNumber(value) {
    if (isEmptyText(value)) {
        return true;
    }
    return !value.match(NUMBER_ONLY_PATTERN);
}

export function isEmptyText(value) {

    // Null and undefined are empty
    if (!isDefined(value)) {
        return true;
    }

    if (isString(value)) {
        return EMPTY_STRING_REGEXP.test(value);
    }
    return false;
}
function isDefined(value) {
    return value !== null && value !== undefined;
}
export function isValidContactName(value: string): boolean {
    return MATCH_TEXT_HYPHENS.test(value);
}
export function isValidAusPhone(value: string): boolean {
    return !!value.match(MATCH_AUS_PATTERN_PHONE);
}
export function hasValidPhoneLength(value: string): boolean {
    return MATCH_PHONE_LENGTH.test(value);
}
export function isValidPhoneNumber(value: string): boolean {
    return MATCH_PHONE_NUMBER_ALLOWED.test(value);
}
export function hasValidLength(value: string): boolean {
    return MAX_LENGTH.test(value);
}
export function hasValidEmailLength(value: string): boolean {
    return MAX_EMAIL_LENGTH.test(value);
}
export function hasValidLastNameLength(value: string): boolean {
    return NAME_LENGTH.test(value);
}
export function hasValidFirstNameLength(value: string): boolean {
    return FIRST_NAME_LENGTH.test(value);
}
export function hasSpaceBefore(value: string): boolean {
    return NAME_STARTING_WITH_SPACE.test(value);
}
export function hasSpaceAroundHyphen(value: string): boolean {
    return SPACES_AROUND_HYPHEN.test(value);
}
export function hasDoubleHyphen(value: string): boolean {
    return DOUBLE_HYPHEN.test(value);
}
export function hasRepeatedCharacters(value: string): boolean {
    return CHARACTER_REPEAT.test(value);
}
export function hasReservedName(value: string): boolean {
    return RESERVED_NAMES_CONFIG[value.toUpperCase().trim()];
}
export function hasPunctuationAtEnd(value: string): boolean {
    return (DOT_AT_END.test(value) ||
        AT_THE_RATE_AT_END.test(value) ||
        HYPHEN_AT_END.test(value) ||
        UNDERSCORE_AT_END.test(value))
}
export function hasSpace(value: string): boolean {
    return SPACE_CHECK.test(value);
}
export function hasAllowedCharacters(value: string): boolean {
    return EMAIL_CHARACTER_ALLOWED.test(value);
}
export function hasSpecialCharaters(value: string): boolean {
    return !!value.match(MOBILE_NUMBER_INCLUDING_PLUS);
}
